import React, { useEffect } from 'react'
import styles from './campaign-edition.styles'
import injectSheet from 'react-jss'
import Container from '../../shared/container/container'
import Main from '../../shared/main/main'
import Paper from 'pobble-components/dist/paper'
import CampaignEditionForm from './campaign-edition-form/campaign-edition-form.container'
import Spinner from 'pobble-components/dist/spinner'

const CampaignEdition = ({ classes, pending, onMount }) => {
  useEffect(() => {
    onMount()
  }, []) // eslint-disable-line

  return (
    <Container>
      <Main>
        <Paper className={classes.paper}>
          {pending && <Spinner />}
          {!pending && <CampaignEditionForm />}
        </Paper>
      </Main>
    </Container>
  )
}

export default injectSheet(styles)(CampaignEdition)
